module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-list', {
    staticClass: "md-triple-line"
  }, _vm._l((_vm.mutations), function(mutation) {
    return _c('md-list-item', {
      key: mutation.id
    }, [_c('div', {
      staticClass: "md-list-text-container"
    }, [_c('span', [_vm._v(_vm._s(mutation.project.title) + " "), _c('span', {
      staticClass: "md-caption"
    }, [_vm._v(_vm._s(mutation.version.version))])]), _vm._v(" "), _c('span', [_vm._v("Changed By: " + _vm._s(mutation.mutation.user))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(mutation.mutation.date.toDateString()))])])])
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d63df66a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/history/revisions-list.vue
// module id = 1290
// module chunks = 21